import React from 'react';
import { ANNOUNCEMENT, SHOPSTAR_GO } from './siteData';
import { trackGoClick } from '../../lib/track';

// Shopstar Go ground, sampled from the official Go logo's pink. Kept light so
// the navy+pink logo and the ink (navy) tagline read at high contrast, and the
// navy CTA pill pops against it. Shared with the pricing card/band via siteData.
const GO_BG = SHOPSTAR_GO.bg;

/**
 * Slim promo bar for Shopstar Go. Rendered as the top strip of the sticky
 * <header>, so it pins to the top of the viewport together with the nav.
 *
 * Fixed heights per breakpoint, so the mobile drawer offset in Header.jsx
 * stays exact:
 *   • phones (< sm): two lines, 56px (h-14)  -> drawer top-[128px] (56 + 72)
 *   • sm and up:     one line,  44px (h-11)  -> drawer sm:top-[116px] (44 + 72)
 *
 * Layout: the official Go logo, the full tagline, and a navy CTA pill. On
 * phones the logo stacks above the tagline + CTA row so nothing is truncated;
 * from sm up it's a single centered row.
 */
const AnnouncementBar = () => (
  <a
    href={ANNOUNCEMENT.href}
    onClick={() => trackGoClick(ANNOUNCEMENT.href, ANNOUNCEMENT.cta)}
    data-testid="marketing-announcement-bar"
    aria-label={`Introducing Shopstar Go — ${ANNOUNCEMENT.tagline} ${ANNOUNCEMENT.cta}`}
    className="group flex h-14 flex-col items-center justify-center gap-1 px-4 text-ink sm:h-11 sm:flex-row sm:gap-3"
    style={{ backgroundColor: GO_BG }}
  >
    <img
      src={ANNOUNCEMENT.logo}
      alt={ANNOUNCEMENT.logoAlt}
      width="139"
      height="20"
      className="h-5 w-auto flex-none"
    />

    <span className="flex items-center gap-2 whitespace-nowrap">
      <span className="text-xs font-medium text-ink/75 sm:text-sm">
        {ANNOUNCEMENT.tagline
          .split(ANNOUNCEMENT.taglineBold)
          .flatMap((part, i) => (i === 0
            ? [part]
            : [<strong key={i} className="font-bold text-ink">{ANNOUNCEMENT.taglineBold}</strong>, part]))}
      </span>

      <span
        data-testid="marketing-announcement-cta"
        className="inline-flex flex-none items-center gap-1 rounded-full bg-ink px-3 py-1 text-xs font-bold text-white transition-transform duration-200 ease-spring animate-cta-pulse group-hover:-translate-y-px sm:text-sm"
      >
        {ANNOUNCEMENT.cta}
        <svg
          className="h-3.5 w-3.5 transition-transform duration-200 ease-spring group-hover:translate-x-0.5"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </span>
  </a>
);

export default AnnouncementBar;
